import { Component, Prop, h } from '@stencil/core';

@Component({
  tag: 'kia-retailers',
  styleUrl: 'kia-retailers.scss',
})
export class Retailers {
  @Prop() storeLink: string;

  render() {
    return (
      <div class="kia_price_card--retailers">
        <a href="https://www.kia.com/se/provkor/">
          <span>Kontakta återförsäljare</span>
          <svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect width="19" height="19" rx="9.5" fill="white" />
            <path d="M8.1665 13.5L12.1665 9.5L8.1665 5.5" stroke="#05141F" stroke-width="2" />
          </svg>
        </a>
        <a href={this.storeLink}>
          <span>Beställ online</span>
          <svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect width="19" height="19" rx="9.5" fill="white" />
            <path d="M8.1665 13.5L12.1665 9.5L8.1665 5.5" stroke="#05141F" stroke-width="2" />
          </svg>
        </a>
      </div>
    );
  }
}
